export const MAX_UPLOAD_FILE_SIZE_MB = 100;

export const MAX_UPLOAD_FILES = 20;

export const MAX_CONCURRENT_UPLOADS = 3;

export function isLessThanUploadLimit(bytes: number, limitMb = MAX_UPLOAD_FILE_SIZE_MB): boolean {
  if (!Number.isFinite(bytes) || bytes < 0) {
    return false;
  }

  const denom = 1_000_000;

  return bytes / denom <= limitMb;
}

export async function runWithConcurrencyLimit<T, R>(
  items: T[],
  limit: number,
  handler: (item: T) => Promise<R>,
): Promise<R[]> {
  if (items.length === 0) {
    return [];
  }

  const results: R[] = new Array(items.length);
  let nextIndex = 0;
  const workerCount = Math.min(limit, items.length);

  const worker = async (): Promise<void> => {
    while (nextIndex < items.length) {
      const currentIndex = nextIndex;

      nextIndex += 1;
      results[currentIndex] = await handler(items[currentIndex]);
    }
  };

  await Promise.all(Array.from({ length: workerCount }, worker));

  return results;
}
